/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Jaswant's Portfolio",
  description:
    // "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
    "A passionate, innovative, task-driven professional with specialization in MERN stack. Looking for an opportunity to make impact on the company's growth as well as his personal growth by contributing his technical and interpersonal skills.",
  og: {
    title: "Jaswant Chaudhary Portfolio",
    type: "website",
    url: "https://jaswants-portfolio.netlify.app/#/",
  },
};

//Home Page
const greeting = {
  title: "Jaswant Chaudhary",
  logo_name: "JaswantChaudhary",
  nickname: "developer_Jaswant",
  subTitle:
    "A passionate, innovative, task-driven professional with specialization in MERN stack. Looking for an opportunity to make impact on the company's growth as well as his personal growth by contributing his technical and interpersonal skills.",
  resumeLink:
    "https://drive.google.com/file/d/1g8-0GiuT4umHrgt-lxyavbeEeeHjt4Rv/view?usp=sharing",
  portfolio_repository: "https://jaswants-portfolio.netlify.app/#/",
  githubProfile: "https://github.com/jchy",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/jchy",
  // linkedin: "https://www.linkedin.com/in/jaswant-chaudhary-651768194/",
  // gmail: "recjaswantcse@gmail.com",
  // gitlab: "https://gitlab.com/jchy",
  // facebook: "https://www.facebook.com/profile.php?id=100079244157209",
  // twitter: "https://twitter.com/recjaswantcse",
  // instagram: "https://www.instagram.com/developerjaswant/"

  {
    name: "Github",
    link: "https://github.com/jchy",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/jaswant-chaudhary-651768194/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://www.youtube.com/channel/UCzueAx2e_WFdM6_Z7dLub7Q",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:recjaswantcse@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/recjaswantcse",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/profile.php?id=100079244157209",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/developerjaswant/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using HTML5, CSS3,JavaScript, React and Redux",
        "⚡ Styling website using CSS3, MUI",
        "⚡ Creating application backend in Node, Express & MongoDB",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "akar-icons:redux-fill",
          style: {
            color: "#764ABC",
          },
        },
        {
          skillName: "Typescript",
          fontAwesomeClassname: "logos:typescript-icon",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "Material-UI",
          fontAwesomeClassname: "simple-icons:mui",
          style: {
            color: "#2196F3",
          },
        },
        // {
        //   skillName: "Bootstrap",
        //   fontAwesomeClassname: "akar-icons:bootstrap-fill",
        //   style: {
        //     color: "#7952B3",
        //   },
        // },
        // {
        //   skillName: "Chakra UI",
        //   fontAwesomeClassname: "simple-icons:chakraui",
        //   style: {
        //     color: "#319795",
        //   },
        // },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "bxl:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySql",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#3178C6",
          },
        },
        // {
        //   skillName: "AWS(EC-2 & S3)",
        //   fontAwesomeClassname: "logos:aws",
        //   style: {
        //     color: "#CB3837",
        //   },
        // },
        // {
        //   skillName: "Websocket",
        //   fontAwesomeClassname: "logos:websocket",
        //   style: {
        //     color: "#F56640",
        //   },
        // },
        {
          skillName: "JWT",
          fontAwesomeClassname: "logos:jwt-icon",
          style: {
            color: "#3178C6",
          },
        },
      ],
    },
    {
      title: "Cloud Server",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Integrating client side to Server",
      ],
      softwareSkills: [
        {
          skillName: "Heroku",
          fontAwesomeClassname: "logos:heroku-icon",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "cib:netlify",
          style: {
            color: "#00C7B7",
          },
        },
        // {
        //   skillName: "Vercel",
        //   fontAwesomeClassname: "akar-icons:vercel-fill",
        //   style: {
        //     color: "#000000",
        //   },
        // },
        // {
        //   skillName: "AWS(EC-2 & S3)",
        //   fontAwesomeClassname: "logos:aws",
        //   style: {
        //     color: "#CB3837",
        //   },
        // },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "bxl:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySql",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#3178C6",
          },
        }
      ],
    },
    {
      title: "Tools and Technology",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for web applications",
        "⚡ Customizing front-end designs and building customer oriented web applicationsfrom scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Codesandbox",
          fontAwesomeClassname: "logos:codesandbox",
          style: {
            color: "#00C300",
          },
        },
        {
          skillName: "Codepen",
          fontAwesomeClassname: "akar-icons:codepen-fill",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "VS Code",
          fontAwesomeClassname: "vscode-icons:file-type-vscode",
          style: {
            color: "#2196F3",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "akar-icons:github-fill",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "logos:postman-icon",
          style: {
            color: "#7952B3",
          },
        },
        // {
        //   skillName: "Chrome Developer Tools(Basic)",
        //   fontAwesomeClassname: "ic:outline-chrome-reader-mode",
        //   style: {
        //     color: "#000000",
        //   },
        // },
        // {
        //   skillName: "Command Line Interface",
        //   fontAwesomeClassname: "clarity:command-line",
        //   style: {
        //     color: "#00C300",
        //   },
        // },
        // {
        //   skillName: "Linux",
        //   fontAwesomeClassname: "logos:linux-tux",
        //   style: {
        //     color: "#00C300",
        //   },
        // },
        // {
        //   skillName: "MacOS",
        //   fontAwesomeClassname: "vscode-icons:folder-type-macos",
        //   style: {
        //     color: "#00C300",
        //   },
        // }
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "GeeksForGeeks",
      iconifyClassname: "simple-icons:geeksforgeeks",
      style: {
        color: "#2F8D46",
      },
      profileLink: "https://auth.geeksforgeeks.org/user/coder_786/profile",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/jaswantchaudhary",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/codera_786",
    },
    {
      siteName: "Leetcode",
      iconifyClassname: "cib:leetcode",
      style: {
        color: "#FFA116",
      },
      profileLink: "https://leetcode.com/jchy/",
    }
  ],
};

const degrees = {
  degrees: [
    {
      title: "Masai School, Bangalore",
      subtitle: "Full Stack Web Developer Course",
      logo_path: "masailogo.gif",
      alt_name: "Masai School",
      duration: "April 2021 - April 2022",
      descriptions: [
        "⚡ I have done Full Stack Web Development Course using MERN stack from Masai School",
        "⚡ Apart from this, I have done courses on Command Line Interface(CLI), Basic AWS Course",
        "⚡ I have learnt HTML5, CSS3, JavaScript, React, Redux,Material UI, Chakra UI, Bootstrap, Typescript, Node.js , Express.js, MongoDb, SQL, JWT, Google-auth 2.0",
      ],
      website_link: "https://masaischool.com/",
    },
    {
      title: "Rajkiya Engineering College Sonbhadra",
      subtitle: "B.Tech. in Computer Science and Engineering",
      logo_path: "RecLogo.png",
      alt_name: "REC Sonbhadra",
      duration: "2018 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, Networks etc.",
        "⚡ Apart from this, I have done courses on Full Stack Development.",
        "⚡ I was selected for 100% Fee Waiver Scholardhip which is given to top 3 of students in college. I have received award from respected director for consistently best performance in academics and Art-club",
      ],
      website_link: "http://recsonbhadra.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Algorithmic Toolbox",
      subtitle: "- Alexander S. Kulikov",
      logo_path: "UnivCalifornia.svg.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/W3CVAM5VMRJU",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Certification Course On Computer System Security",
      subtitle: "- Prof. Amey Karkare",
      logo_path: "iitk.png",
      certificate_link:
        "https://drive.google.com/file/d/1Y23N_KlhC9zhZavm_YGYwDeTlJic6GtX/view?usp=drivesdk",
      alt_name: "IITKanpur",
      color_code: "#003D8F",
    },
    // {
    //   title: "Complete Linux Training Course",
    //   subtitle: "- Imran Afzal",
    //   logo_path: "Udemy-Logo.png",
    //   certificate_link:
    //     "https://www.udemy.com/certificate/UC-d4a80ea5-2f5d-49b2-aeee-7c1b1e19ad41/",
    //   alt_name: "UDEMY",
    //   color_code: "#76D04B",
    // },
    {
      title: "Developing Soft Skills and Personality",
      subtitle: "- Prof. Satyaki Roy",
      logo_path: "iitk.png",
      certificate_link:
        "https://drive.google.com/file/d/1cU4DseprqNDcRcJ4fRzkIHTAtMxrm0tZ/view?usp=drivesdk",
      alt_name: "IITKanpur",
      color_code: "#000000",
    },
    // {
    //   title: "Python Basics",
    //   subtitle: "- Paul Resnik",
    //   logo_path: "MichiganLogo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/22TMGLFZYAKL",
    //   alt_name: "University of Michigan",
    //   color_code: "#8C151599",
    // },
    // {
    //   title: "Python Data Structures",
    //   subtitle: "- Charles Severance",
    //   logo_path: "MichiganLogo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/AJQBH8UWDDV6",
    //   alt_name: "University of Michigan",
    //   color_code: "#FF9E0F",
    // }
  ],
};

// Experience Page
const experience = {
  title: "Achievements",
  subtitle: "Full Stack Web Developer",
  description:
    "I have worked with many Industry experts on collaborative projects and made some wonderful projects. It's been a great experience of learning, testing, collaborating and deploying the the production ready code with developers across the India. I got to learn so many new things and at the same time I was also able to share my knowledge and expertise with others",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Achievements",
      experiences: [
        {
          title: "Gold Medalist at IMO",
          company: "International Mathematical Olympiad",
          company_url: "https://www.imo-official.org/",
          logo_path: "IMOLogo.gif",
          duration: "13th January 2013 - 13th of January 2013",
          location: "Sonbhadra, Uttar Pradesh, India",
          description:
            "Gold Medalist at Internatioal Mathematics Olympiad Contest. Honoured by secretary of council for elementy education",
          color: "#181717",
        },
        {
          title: "Bronze Medalist at Regional Athletics Meet",
          company: "Jawahar Navodaya Vidyalaya Samiti",
          company_url: "https://navodaya.gov.in/",
          logo_path: "jnvs.jpeg",
          duration: "16th of Septeber 2013 - 18th of September 2013",
          location: "Sonbhadra, Uttar Pradesh, India",
          description:
            "Bronze Medalist at Regional Athletics Meet Bhopal, M.P., 2013. Honoured by Ministry of H.R.D., Department of education, Govt. of India",
          color: "#181717",
        },
        {
          title: "Gold medalist at sketching competetion",
          company: "REC Sonbhadra",
          company_url:
            "https://www.recsonbhadra.ac.in/",
          logo_path: "RecLogo.png",
          duration: "October 2018 - October 2018",
          location: "Sonbhadra, Uttar Pradesh",
          description:
            "Gold medalist at sketching competetion at 2nd of October, 2018 Gandhi Jayanti. Honoured by Director of the REC Sonbhadra",
          color: "#0C9D58",
        },
        {
          title: "Gold medalist in Science Debate",
          company: "Siiddharthnagar District Science Club",
          company_url: "https://siddharthnagar.nic.in/",
          logo_path: "GOIUP.svg",
          duration: "Jan 2013 - jan 2013",
          location: "Sonbhadra, Uttar Pradesh, India",
          description:
            "Gold medalist in Science Debate at Siddharthnagar District Scienec Club, honoured by District Magistrate ",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools like HTML5, CSS3, JavaScript, React, Redux, Typescript, Material UI, Chakraui, Boootstrap for front end. Node.js, Express JS, MongoDB, SQL for backend development. Heroku, Netlify, Vercel, AWS, Mogodb Atlas as cloud infrastructure and Github, VS-Code, Codepen and Codesandbox as tools. My best experience is to create Full stack web applications projects and deploy them using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Tech Blogs",
  description:
    "I have worked on, researched and published blogs in tech filed which will create a positive impact on the audience",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "jaswantLogos.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with HTML5, CSS3, Javascript, React, Redux, Typescript, MUI, Chakra UI, Node.js, Express.js, MongoDB, SQL, MongoDB Atlas, Heroku, Netlify, Vercel, Github and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I am passionate about writing blogs. For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to enhance their understanding of the topic and knowledge base.",
    link: "https://www.linkedin.com/in/jaswantchaudhary/recent-activity/posts/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Siddharthnagar, Uttar Pradesh, India, PIN - 272153",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/PMyT4TQgK9Zbe77H7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9648976787",
  },
};
const contactPageDataHome = {
  contactSection: {
    title: "Jaswant Chaudhary",
    profile_image_path: "jaswantLogos.png",
    description:
      "A passionate, innovative, task-driven professional with specialization in MERN stack. Looking for an opportunity to make impact on the company's growth as well as personal growth by contributing technical and interpersonal skills.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I am passionate about writing blogs. For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to enhance their understanding of the topic and knowledge base.",
    link: "https://www.linkedin.com/in/jaswantchaudhary/recent-activity/posts/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Siddharthnagar, Uttar Pradesh, India, PIN - 272153",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/PMyT4TQgK9Zbe77H7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9648976787",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
  contactPageDataHome,
};
